// extracted by mini-css-extract-plugin
export default {"container":"collection-header-description_container__2rzF2"};